// Registers the offline service worker. Called once from main.tsx.
// Opt-in: we only register on HTTPS / localhost (browser requirement) and when
// navigator.serviceWorker is available — older Safari in private mode skips it.
//
// Auto-update pattern: when a new SW takes control of the page
// (`controllerchange` fires after the new worker calls
// `clients.claim()`), we force a single page reload. Without this,
// a just-deployed bundle is only visible after the next manual
// refresh — which the user often doesn't know to do, so the page
// keeps trying to load asset hashes that no longer exist and the
// browser logs MIME-mismatch errors.

export function registerServiceWorker(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  if (
    typeof window !== "undefined" &&
    window.location.protocol !== "https:" &&
    window.location.hostname !== "localhost"
  ) {
    return;
  }

  let hasReloaded = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (hasReloaded) return;
    hasReloaded = true;
    window.location.reload();
  });

  window.addEventListener("load", () => {
    navigator.serviceWorker
      // updateViaCache: "none" — never let the HTTP cache satisfy the sw.js
      // update check, so a fixed worker is picked up on the very next check
      // even if an intermediate cached the old script.
      .register("/sw.js", { updateViaCache: "none" })
      .then((reg) => {
        // The browser only checks for a newer worker on navigation by
        // default, so a tab left open across a deploy can keep running a
        // stale worker that serves now-removed asset hashes (white screen).
        // Poll on registration and whenever the tab regains focus so a fixed
        // worker reaches long-lived tabs quickly without a manual refresh.
        const check = () => {
          reg.update().catch(() => {});
        };
        check();
        document.addEventListener("visibilitychange", () => {
          if (document.visibilityState === "visible") check();
        });
      })
      .catch((err) => {
        console.warn("service worker registration failed", err);
      });
  });
}
